// extracted by mini-css-extract-plugin
export default {"deck":"deck___pEUt0","three":"three___2gXwp","four":"four___1g194"};